import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { registerApi } from '../../api/authApi';
import { supabase } from '../../App';

function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    username: '',
    bgmiUsername: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /* OAuth Handler */
  const handleOAuthLogin = async (provider) => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: provider,
        options: {
          redirectTo: `${window.location.origin}/dashboard/matches`
        }
      });

      if (error) {
        toast.error(error.message);
      }
    } catch (error) {
      toast.error('Failed to register with ' + provider);
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.email || !formData.password || !formData.username || !formData.bgmiUsername) {
      toast.error('Please fill in all required fields');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      // Use backend API instead of direct Supabase call
      const response = await registerApi({
        email: formData.email,
        password: formData.password,
        username: formData.username,
        bgmi_username: formData.bgmiUsername,
      });

      console.log('Registration successful:', response);

      toast.success('Account created successfully! Please login 🎮');
      navigate('/login');

    } catch (error) {
      console.error('Registration error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to register';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-header">
        <h1 className="game-title">
          <span className="zero">ZERO</span>
          <span className="ping">PING</span>
        </h1>
        <p className="tagline">Battle Royale Tournament Platform</p>
      </div>

      <div className="card" style={{ width: '100%', maxWidth: '450px' }}>
        <Link
          to="/"
          style={{
            background: 'transparent',
            border: 'none',
            color: 'var(--primary-color)',
            cursor: 'pointer',
            fontSize: '0.9rem',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            textDecoration: 'none'
          }}
        >
          ← Back to Home
        </Link>

        <h2 style={{
          fontSize: '2rem',
          marginBottom: '10px',
          textAlign: 'center',
          fontFamily: 'Orbitron, sans-serif',
          color: 'var(--secondary-color)'
        }}>
          REGISTER
        </h2>
        <p style={{
          textAlign: 'center',
          color: 'var(--text-secondary)',
          marginBottom: '30px',
          fontSize: '0.9rem'
        }}>
          Join the elite warriors
        </p>

        <form onSubmit={handleRegister}>
          <div className="form-group">
            <label className="form-label">Username *</label>
            <input
              type="text"
              name="username"
              className="form-input"
              placeholder="ProGamer123"
              value={formData.username}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">BGMI Username *</label>
            <input
              type="text"
              name="bgmiUsername"
              className="form-input"
              placeholder="Your BGMI IGN"
              value={formData.bgmiUsername}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email *</label>
            <input
              type="email"
              name="email"
              className="form-input"
              placeholder="warrior@zeroping.gg"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password *</label>
            <input
              type="password"
              name="password"
              className="form-input"
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Confirm Password *</label>
            <input
              type="password"
              name="confirmPassword"
              className="form-input"
              placeholder="••••••••"
              value={formData.confirmPassword}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-secondary"
            style={{ width: '100%', marginTop: '10px' }}
            disabled={loading}
          >
            {loading ? 'Creating Account...' : 'Register'}
          </button>

          <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
            <div style={{ flex: 1, borderBottom: '1px solid var(--border-color)' }}></div>
            <span style={{ padding: '0 10px', color: 'var(--text-secondary)', fontSize: '0.8rem' }}>OR</span>
            <div style={{ flex: 1, borderBottom: '1px solid var(--border-color)' }}></div>
          </div>

          <button
            type="button"
            className="btn"
            style={{
              width: '100%',
              background: '#ffffff',
              color: '#333',
              marginBottom: '10px',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold'
            }}
            onClick={() => handleOAuthLogin('google')}
            disabled={loading}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px' }}>
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fillRule="evenodd" fillOpacity="1" fill="#4285f4" stroke="none"></path>
              <path d="M9.003 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.715H.957v2.332A8.997 8.997 0 0 0 9.003 18z" fillRule="evenodd" fillOpacity="1" fill="#34a853" stroke="none"></path>
              <path d="M3.964 10.712c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.96H.957a8.996 8.996 0 0 0 0 6.09l3.007-2.338z" fillRule="evenodd" fillOpacity="1" fill="#fbbc05" stroke="none"></path>
              <path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9.003 0 5.488 0 2.453 2.026.957 4.96l3.007 2.338c.708-2.13 2.692-3.715 5.039-3.715z" fillRule="evenodd" fillOpacity="1" fill="#ea4335" stroke="none"></path>
            </svg>
            Continue with Google
          </button>

          <div style={{
            textAlign: 'center',
            marginTop: '20px',
            color: 'var(--text-secondary)'
          }}>
            Already have an account?{' '}
            <Link
              to="/login"
              style={{
                color: 'var(--secondary-color)',
                textDecoration: 'underline',
                fontFamily: 'Rajdhani, sans-serif'
              }}
            >
              Login here
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;